import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

  constructor(
    public loader: LoadingBarService,
    private cd: ChangeDetectorRef
  ) { }
  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
}
